import { api } from './api';

export interface CalibrationGuidance {
  version: 1;
  instructions: string;
  updatedAt: string;
  defaultInstructions: string;
  maxChars: number;
}

export const calibrationGuidanceApi = {
  get: () => api.get<CalibrationGuidance>('/api/look-at-that/calibration-guidance'),
  save: (instructions: string) =>
    api.put<CalibrationGuidance>('/api/look-at-that/calibration-guidance', { instructions }),
  restore: () =>
    api.post<CalibrationGuidance>('/api/look-at-that/calibration-guidance/restore'),
};
